// Vue CLI automatically replaces process.env.VUE_APP_* variables at build time
const APP_RELEASE = process.env.VUE_APP_APP_RELEASE || '';
const SENTRY_DSN = process.env.VUE_APP_SENTRY_DSN || '';
const SENTRY_ENVIRONMENT = process.env.VUE_APP_SENTRY_ENVIRONMENT || '';

interface SentryConfig {
    dsn: string;
    environment: string;
    release: string;
    tracesSampleRate: number;
    sendDefaultPii: boolean;
}

function getEnvironment(): string {
    if (SENTRY_ENVIRONMENT in ['development', 'staging', 'production']) {
        return SENTRY_ENVIRONMENT;
    }

    return 'development';
}

const getRelease = (): string => APP_RELEASE || '1.0.0';

function getSentryConfig(): SentryConfig {
    const environment = getEnvironment();
    const isProduction = environment === 'production';

    return {
        dsn: SENTRY_DSN,
        environment,
        release: getRelease(),
        tracesSampleRate: isProduction ? 0.1 : 1.0,
        sendDefaultPii: true,
    };
}

export function initSentry(app: any, Sentry: any): void {
    const config = getSentryConfig();
    const isDevelopment = config.dsn === '';

    // Skip Sentry initialization entirely for development
    if (isDevelopment) {
        return;
    }

    // Initialize Sentry with config for non-development environments
    Sentry.init({
        app,
        ...config,
    });

    // Set additional context after initialization
    if (typeof window !== 'undefined') {
        try {
            // Set environment-specific context
            Sentry.setContext('service', {
                hostname: window.location.hostname,
                userAgent: navigator.userAgent,
                timestamp: new Date().toISOString(),
                url: window.location.href,
                environment: getEnvironment(),
            });

            // Set tags for better filtering in Sentry
            Sentry.setTag('component', 'frontend');
            Sentry.setTag('language', 'typescript');
        } catch (error) {
            // Silently fail if there's an error
            console.warn('Failed to set Sentry context:', error);
        }
    }
}
